import React, { Component, createRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Card, CardMedia, IconButton, CircularProgress } from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import PlayArrowIcon from "@material-ui/icons/PlayArrow"; // Importa el icono de Play
import Config from '../../../config';
import BeatLoader from 'react-spinners/BeatLoader';

const spinnerCss = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  marginLeft: '-30px'
}

class UploadMedia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      captureMode: "",
      mediaFiles: [],
      previewFile: null,
      previewType: "",
      loading: false, // Nuevo estado para manejar el loading
      isHistoric: false
    };
    this.fileInputRef = createRef();
  }

  // Este ciclo de vida se ejecuta cuando el componente es montado
  componentDidMount() {

    this.getImagesFromS3();
    const path = window.location.pathname;
    const segments = path.split('/'); // Divide la URL en segmentos
    const historico = segments[segments.indexOf('historico')]; // Busca y obtiene la palabra 'historico'

    console.log(historico);  // 'historico'
    if (historico !== undefined) {
      this.setState({
        isHistoric: true
      })
    }
    
  }

  handleOpenDialog = () => {
    this.setState({ open: true });
  };

  handleCloseDialog = () => {
    this.setState({ open: false });
  };

  handleChooseOption = (mode) => {
    this.setState({ captureMode: mode }, () => {
      this.fileInputRef.current.click();
    });
    this.handleCloseDialog();
  };

  handlePreview = (file) => {
    this.setState({ previewFile: file.src, previewType: file.type });
  };

  handleClosePreview = () => {
    this.setState({ previewFile: null, previewType: "" });
  };

  handleFileChange = async (event) => {
    this.setState({ loading: true });
    const files = event.target.files;
    if (files.length > 0) {
      const file = files[0];
      const fileType = file.type.startsWith("image") ? "image" : "video";
      const fileExtension = file.name.split('.').pop();
      const uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
      const uniqueFileName = `${uniqueId}.${fileExtension}`;

      try {
        const s3UrlResponse = await this.saveImageOrVideo({ name: uniqueFileName, type: fileType, file });
        if (s3UrlResponse) {
          await this.uploadToS3({ name: uniqueFileName, type: file.type, file }, s3UrlResponse);
          this.getImagesFromS3();
        }
      } catch (error) {
        console.log('Error al subir archivo:', error);
      }
    }
  };

  handleDeleteFile = (index) => {
    console.log(this.state.mediaFiles[index]);
    this.deleteImageFromS3(this.state.mediaFiles[index].name, index);
    // this.setState((prevState) => ({
    //   mediaFiles: prevState.mediaFiles.filter((_, i) => i !== index),
    // }));
  };

  async getImagesFromS3() {
    this.setState({ loading: true });
    const settings = {
      method: 'GET',
      headers: {
        'accessToken': this.props.accessToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };

    // Usamos el nombre del archivo en la URL
    const fetchResponse = await fetch(`${Config.apiGateway.URL}CheckControl/Files/Download/${this.props.deviceCheckControlId}`, settings);

    if (fetchResponse.ok) {
      if (fetchResponse !== null) {
        try {
          const responseJson = await fetchResponse.json();

          // Función para determinar si es una imagen o un video
          const getFileType = (url) => {
            const fileName = url.split('/').pop().split('?')[0]; // Extraemos el nombre del archivo

            // Usamos una expresión regular para encontrar la extensión antes del guion bajo o caracteres extra
            const extensionMatch = fileName.match(/\.([a-zA-Z0-9]+)(?=[^a-zA-Z0-9]|$)/);
            const extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';

            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
            const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];

            if (imageExtensions.includes(extension)) {
              return 'image';
            } else if (videoExtensions.includes(extension)) {
              return 'video';
            } else {
              return 'unknown'; // O puedes devolver otro valor si no es reconocido
            }
          };

          // Mapeamos los URLs y les asignamos el tipo correspondiente
          this.setState({
            mediaFiles: responseJson.map(url => ({
              type: getFileType(url),
              src: url,
              name: url.split('/').pop().split('?')[0],
            })),
            loading: false,
          });
        } catch (error) {
          console.log(error);
          this.setState({ loading: false });
        }
      }
    } else {
      // La respuesta no es exitosa
      console.log('Error en la respuesta:', fetchResponse.status);
      this.setState({ loading: false });
    }
  }



  async saveImageOrVideo(file) {
    this.setState({ loading: true });
    const fileName = file.name; // Extraemos el nombre del archivo desde el objeto file

    const settings = {
      method: 'GET',
      headers: {
        'accessToken': this.props.accessToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    };

    // Usamos el nombre del archivo en la URL
    const fetchResponse = await fetch(`${Config.apiGateway.URL}CheckControl/Files/Upload?DeviceCheckControlId=${this.props.deviceCheckControlId}&FileName=${fileName}`, settings);

    if (fetchResponse.ok) {
      if (fetchResponse !== null) {
        try {
          const responseJson = await fetchResponse.json();
          return responseJson; // Aquí esperamos la URL de S3, se devuelve como respuesta
        } catch (error) {
          console.log(error);
          this.setState({ loading: false }); // Detener el loading
        }
      }
    } else {
      // La respuesta no es exitosa
      if (fetchResponse.status === 400) {
        // this.setState({
        //   snackbarOpen: true,
        //   message: await fetchResponse.json(),
        // });
      } else {
        console.log('Otro error:', fetchResponse.status);
      }
    }
  }


  async uploadToS3(file, s3Url) {
    console.log(file.file);
    const settings = {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,  // Usamos el tipo del archivo (image/video)
      },
      body: file.file,  // Aquí pasamos el contenido base64 del archivo
    };



    try {
      const uploadResponse = await fetch(s3Url, settings);

      if (uploadResponse.ok) {
        console.log('Archivo cargado exitosamente en S3');
        this.setState({ loading: false }); // Detener el loading
        //return await uploadResponse.json(); // Dependiendo de lo que devuelva el PUT (por ejemplo, confirmación de carga)
      } else {
        console.log('Error al cargar archivo a S3:', uploadResponse.status);
        this.setState({ loading: false }); // Detener el loading
      }
    } catch (error) {
      console.log('Error en la carga a S3:', error);
      this.setState({ loading: false }); // Detener el loading
    }
  }

  async handleMediaFilesUpload() {
    const { mediaFiles } = this.state;

    for (const file of mediaFiles) {
      try {
        // Llamamos a la API para obtener la URL de S3
        const s3UrlResponse = await this.saveImageOrVideo(file);
        console.log(s3UrlResponse);
        if (s3UrlResponse !== undefined) {
          // Una vez que tengamos la URL de S3, realizamos el PUT con el base64
          await this.uploadToS3(file, s3UrlResponse);
        }
      } catch (error) {
        console.log('Error al procesar archivo:', error);
      }
    }
  }

  async deleteImageFromS3(path, index) {
    const pathFile = this.props.deviceCheckControlId + '/' + path;
    const encodedPath = encodeURIComponent(pathFile);
    console.log(pathFile);

    this.setState({ loading: true });
    const settings = {
      method: 'DELETE',
    };

    try {
      const fetchResponse = await fetch(`${Config.apiGateway.URL}CheckControl/Files/${encodedPath}`, settings);

      if (fetchResponse.ok) {
        console.log('Archivo eliminado exitosamente en S3');
        this.removeItemByIndex(index);
        this.setState({ loading: false });
        //return await fetchResponse.json(); // Dependiendo de lo que devuelva el PUT (por ejemplo, confirmación de carga)
      } else {
        console.log('Error al eliminar el archivo de S3:', fetchResponse.status);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log('Error en la carga a S3:', error);
      this.setState({ loading: false });
    }
  }

  // Suponiendo que quieres eliminar el item por su índice
  removeItemByIndex(indexToRemove) {
    this.setState(prevState => {
      // Filtramos los elementos y eliminamos el que tiene el índice indicado

      const updatedMediaFiles = prevState.mediaFiles.filter((item, index) => index !== indexToRemove);
      return { mediaFiles: updatedMediaFiles };
    });
  }

  render() {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        {/* Mostrar el indicador de carga si loading es true */}
        {this.state.loading && (
          <div className="loadingSpinner">
            <BeatLoader css={spinnerCss} size={15} margin={4} color={"#bf2349"} />
          </div>
        )}
        {/* Botón para abrir el diálogo */}
        <Button
          style={{ width: "200px", borderRadius: "10px", fontSize: "1.2rem", fontWeight: "bold", display: this.state.isHistoric ? 'none' : '' }}
          variant="outlined"
          onClick={this.handleOpenDialog}
          
        >
          Subir Foto/Video
        </Button>

        {/* Diálogo de selección */}
        <Dialog open={this.state.open} onClose={this.handleCloseDialog}>
          <DialogTitle>Selecciona una opción</DialogTitle>
          <DialogContent>
            <Button
              fullWidth
              startIcon={<PhotoCameraIcon />}
              onClick={() => this.handleChooseOption("environment")}
              style={{ marginBottom: "10px" }}
            >
              Tomar Foto/Video
            </Button>
            <Button fullWidth startIcon={<PhotoLibraryIcon />} onClick={() => this.handleChooseOption("")}>
              Elegir desde Galería
            </Button>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color="secondary">
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Input oculto para subir archivos */}
        <input
          type="file"
          accept="image/*,video/*"
          capture={this.state.captureMode || undefined}
          ref={this.fileInputRef}
          onChange={this.handleFileChange}
          style={{ display: "none" }}
        />

        {/* Galería de imágenes/videos mejorada */}
        {this.state.mediaFiles.length > 0 && (
          <Grid
            container
            spacing={2}
            style={{
              marginTop: "20px",
              justifyContent: "center",
              maxWidth: "80%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {this.state.mediaFiles.map((file, index) => (
              <Grid
                item
                key={index}
                xs={6} // 2 items por fila en móviles (tamaño xs)
                sm={6} // 2 items por fila en pantallas medianas (tamaño sm)
                md={6} // 2 items por fila en pantallas grandes (tamaño md)
                lg={6} // 2 items por fila en pantallas grandes (tamaño lg)
                style={{
                  position: "relative",
                  maxWidth: "100%", // Asegura que no se salga del contenedor
                  boxSizing: "border-box", // Evita que el padding haga que el contenido se desborde
                }}
              >
                <Card
                  onClick={() => this.handlePreview(file)}
                  style={{
                    cursor: "pointer",
                    overflow: "hidden",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    transition: "transform 0.3s",
                    width: "100%", // Asegura que las cards ocupen todo el ancho disponible
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  {file.type === "image" ? (
                    <CardMedia
                      component="img"
                      image={file.src}
                      style={{
                        height: "140px",
                        objectFit: "cover",
                        width: "100%", // Asegura que la imagen ocupe el 100% del contenedor
                      }}
                    />
                  ) : (
                    <>
                      <CardMedia
                        component="video"
                        src={file.src}
                        style={{
                          height: "140px",
                          objectFit: "cover",
                          width: "100%", // Asegura que el video ocupe el 100% del contenedor
                        }}
                      />
                      {/* Icono de play sobre el video */}
                      <IconButton
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "white",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        onClick={() => this.handlePreview(file)} // Puedes ajustar la acción aquí
                      >
                        <PlayArrowIcon fontSize="large" />
                      </IconButton>
                    </>
                  )}
                </Card>

                {/* Botón de eliminar */}
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleDeleteFile(index);
                  }}
                  style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                    backgroundColor: "rgba(255,255,255,0.8)",
                    color: "red",
                    padding: "5px",
                    display: this.state.isHistoric ? 'none' : 'block'
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            ))}
          </Grid>
        )}

        {/* Dialog para previsualización en grande */}
        <Dialog open={!!this.state.previewFile} onClose={this.handleClosePreview} maxWidth="xl" fullScreen>
          <DialogContent
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "#000",
            }}
          >
            {this.state.previewType === "image" ? (
              <img src={this.state.previewFile} alt="Vista previa" style={{ maxWidth: "90%", maxHeight: "90%" }} />
            ) : (
              <video
                controls
                autoPlay
                style={{ maxWidth: "90%", maxHeight: "90%" }}
              >
                <source src={this.state.previewFile} type="video/mp4" />
                <source src={this.state.previewFile} type="video/quicktime" />
                <source src={this.state.previewFile} type="video/webm" />
                Tu navegador no soporta la reproducción de este video.
              </video>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePreview} color="secondary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default UploadMedia;
